import * as actions from './slice'
import { stackAlert } from '../toast/helpers'

// Adhoc error handler added in PlaylistView
export const getPlaylist = {
  eventName: 'playlistGet',
  onSuccess: {
    action: actions.setDetail,
    redux: true
  }
}

export const getPlaylistContent = {
  eventName: 'playlistListContent',
  onStart: {
    action: actions.setLoading,
    redux: true
  },
  onSuccess: {
    // Not `setContent`: that one carries the user's own edits and is always
    // honoured, while a fetched list is dropped when no playlist is being
    // shown — see the slice.
    action: actions.setFetchedContent,
    redux: true
  },
  onError: {
    action: stackAlert('Unable to get the playlist content', 'error'),
    redux: true
  }
}

export const batchGetPlaylistReadTimes = {
  eventName: 'playlistBatchGetReadTime',
  onSuccess: {
    action: actions.setReadTimes,
    redux: true
  }
}
